import { fetchPolicyListFailure, fetchPolicyListSuccess } from "./reducer"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { POLICY_LIST_API } from "../../constants/constants";

export const getAllPolicies = (setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${POLICY_LIST_API}`, 'GET')
        setLoading(false)
        if (response.error && response.error.code === 'NotFound') {
            dispatch(fetchPolicyListSuccess([]));
        }
        else {
            dispatch(fetchPolicyListSuccess(response.reverse()));
        }
    } catch (error) {
        dispatch(fetchPolicyListFailure(error.message));
    }
};

